import * as firebase from "firebase/app";

import React, {Component} from "react";
import { motion } from "framer-motion";
import Footer from "../Footer";
import Meta from "../../helpers/meta";
import Nav from "../Nav";
import PromoSlider from "./PromoSlider";
import {Redirect} from "react-router";
import RestaurantList from "./RestaurantList";
import {connect} from "react-redux";
import {getFeaturedItems, getFeaturedStores, getPromoSlides} from "../../../services/promoSlider/actions";

import messaging from "../../../init-fcm";
import {saveNotificationToken} from "../../../services/notification/actions";
import {getSingleLanguageData} from "../../../services/languages/actions";
import {getUserNotifications} from "../../../services/alert/actions";
import {resetBackup, resetInfo, resetItems} from "../../../services/items/actions";

import {Link} from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import GpsSelector from "../Location/PopularPlaces/GpsSelector";
import Axios from "axios";
import {GET_ADDRESS_FROM_COORDINATES} from "../../../configs";
import ContentLoader from "react-content-loader";
import moment from "moment";
import toast from "react-hot-toast";
import RunningStatus from "./RunningOrderStatus";
import FeaturedStores from "./FeaturedStores";
import FeaturedItems from "./FeaturedItems";

class Home extends Component {
	static contextTypes = {
		router: () => null,
	};

	state = {
		open: false,
		loadingSlider: true,
		lat: null,
		lng: null
	};

	componentDidMount() {
		this.props.resetItems();
		this.props.resetInfo();
		this.props.resetBackup();

		const {user} = this.props;

		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));

		const userAlreadySelected = !JSON.parse(localStorage.getItem("userSetAddress")).hasOwnProperty(
			"businessLocation"
		);

		if (localStorage.getItem("userAlreadySelectedLocation") === null) {
			if (userAlreadySelected) {
				this.setState({ open: false });
			} else {
				this.getMyLocation();	
				// this.setState({ open: true });
			}
		}

		this.props.getPromoSlides(userSetAddress.lat, userSetAddress.lng);
		this.props.getFeaturedStores(userSetAddress.lat, userSetAddress.lng);
		this.props.getFeaturedItems(userSetAddress.lat, userSetAddress.lng);



		if (user.success) {
			this.props.getUserNotifications(user.data.id, user.data.auth_token);
		}

		if (user.success) {
			if (localStorage.getItem("enablePushNotification") === "true") {
				if (firebase.messaging.isSupported()) {
					let handler = this.props.saveNotificationToken;
					messaging
						.requestPermission()
						.then(async function () {
							const push_token = await messaging.getToken();
							handler(push_token, user.data.id, user.data.auth_token);
						})
						.catch(function (err) {
							console.log("Unable to get permission to notify.", err);
						});
				}
			}

			if (localStorage.getItem("firebase_push_id")) {

				// alert("firebase push id - "+localStorage.getItem("firebase_push_id"));

				const push_token = localStorage.getItem("firebase_push_id");
				let handler = this.props.saveNotificationToken;

				handler(push_token, user.data.id, user.data.auth_token);

				/*messaging
					.requestPermission()
					.then(async function () {
						const push_token = await localStorage.getItem("firebase_push_id");
						console.log(push_token);
						handler(push_token, user.data.id, user.data.auth_token);
					})
					.catch(function (err) {
						console.log("Unable to get permission to notify.", err);
					});*/
			}

			/*try{
				if (navigator.userAgent === "DelivorAndroidWebViewUA" && window.Android.getFcmToken()) {
					let handler = this.props.saveNotificationToken;
					messaging
						.requestPermission()
						.then(async function () {
							const push_token = await window.Android.getFcmToken();
							handler(push_token, user.data.id, user.data.auth_token);
						})
						.catch(function (err) {
							console.log("Unable to get permission to notify.", err);
						});
				}
			}
			catch (e) {
				console.log("There was an error trying to fetch fcm token.");
			}*/

		}


		this.state.loadingSlider = false;
	}

	startLoading = () => {
		document.getElementById("gpsLoadingScreen").classList.remove("hidden");
	};

	stopLoading = () => {
		document.getElementById("gpsLoadingScreen").classList.add("hidden");
	};

	getMyLocation = () => {
		// toast.success('Fetching your current location', { duration: 1000, position: "bottom-center" })

		let self = this;
		toast.promise(new Promise(async function (resolve, reject){


			self.startLoading();

			const location = navigator && navigator.geolocation;
			if (location) {

				await location.getCurrentPosition(
					(position) => {
						self.reverseLookup(position.coords.latitude, position.coords.longitude);
						self.setState({
							lat: position.coords.latitude,
							lng: position.coords.longitude
						})
						resolve();
					},
					(error) => {

						self.setState({ gps_loading: false });
						self.stopLoading();

						console.log(error);

						if (navigator.userAgent !== "FoodomaaAndroidWebViewUA") {
							// alert("");
							reject();
							// toast.error('Please make sure your gps location is turned on.', { duration: 3000, position: "bottom-center" })

						}
					},
					{ timeout: 5000 }
				);
			} else {
				this.stopLoading();
				reject();
			}

		}),{
			loading: 'Fetching your current location',
			success: 'Location has been fetched',
			error: 'Please make sure your gps location is turned on.',
		});


	};

	reverseLookup = (lat, lng) => {
		Axios.post(GET_ADDRESS_FROM_COORDINATES, {
			lat: lat,
			lng: lng,
		})
			.then((response) => {
				// console.log(response);
				const myLocation = [
					{
						formatted_address: response.data,
						geometry: {
							location: {
								lat: lat,
								lng: lng,
							},
						},
					},
				];
				this.handleGeoLocationClick(myLocation);
			})
			.catch(function(error) {
				console.warn(error.response.data);
			});
	};

	handleGeoLocationClick = (results) => {
		const saveGeoLocation = new Promise((resolve) => {
			localStorage.setItem("geoLocation", JSON.stringify(results[0]));
			resolve("GeoLocation Saved");
		});
		saveGeoLocation.then(() => {
			this.stopLoading();
			if (/*this.props.fetchGpsAutomaticallyAndroid*/ true) {
				//set user location but with business flag (do not redirect to address saving)
				const userSetAddress = {
					lat: JSON.parse(localStorage.getItem("geoLocation")).geometry.location.lat,
					lng: JSON.parse(localStorage.getItem("geoLocation")).geometry.location.lng,
					address: JSON.parse(localStorage.getItem("geoLocation")).formatted_address,
					house: null,
					tag: null,
					businessLocation: true,
				};
				const saveUserSetAddress = new Promise((resolve) => {
					localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
					localStorage.setItem("userAlreadySelectedLocation", "true");
					resolve("Location Saved");
				});
				saveUserSetAddress.then(() => {
					window.location.reload();
				});
			} else {
				this.context.router.history.push("/my-location");
			}
		});
	};


	componentWillReceiveProps(nextProps) {
		if (this.props.languages !== nextProps.languages) {
			if (localStorage.getItem("userPreferedLanguage")) {
				this.props.getSingleLanguageData(localStorage.getItem("userPreferedLanguage"));
			} else {
				if (nextProps.languages.length) {
					// console.log("Fetching Translation Data...");
					const id = nextProps.languages.filter((lang) => lang.is_default === 1)[0].id;
					this.props.getSingleLanguageData(id);
				}
			}
		}
	}

	handlePopularLocationClick = (location) => {
		/*const userSetAddress = {
			lat: location.latitude,
			lng: location.longitude,
			address: location.name,
			house: null,
			tag: null,
			businessLocation: true,
		};
		localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));

		const saveUserSetAddress = new Promise((resolve) => {
			localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
			localStorage.setItem("userAlreadySelectedLocation", "true");
			resolve("Location Saved");
		});
		saveUserSetAddress.then(() => {
			window.location.reload();
		});*/
	};

	componentWillUnmount() {
		// navigator.serviceWorker.removeEventListener("message", message => console.log(message));
	}

	render() {
		if (window.innerWidth > 768) {
			return <Redirect to="/"/>;
		}

		const {history, user, promo_slides, popular_locations, featured_stores, featured_items} = this.props;

		return (
				<React.Fragment>
				<Meta
					seotitle={localStorage.getItem("seoMetaTitle")}
					seodescription={localStorage.getItem("seoMetaDescription")}
					ogtype="website"
					ogtitle={localStorage.getItem("seoOgTitle")}
					ogdescription={localStorage.getItem("seoOgDescription")}
					ogurl={window.location.href}
					twittertitle={localStorage.getItem("seoTwitterTitle")}
					twitterdescription={localStorage.getItem("seoTwitterDescription")}
				/>

				<div className="height-100-percent bg-dl-pale mb-50">
					<Nav
						logo={true}
						active_nearme={true}
						disable_back_button={true}
						history={history}
						loggedin={user.success}
					/>

					{localStorage.getItem("customHomeMessage") !== "<p></p>" &&
						localStorage.getItem("customHomeMessage") !== "<p><br></p>" &&
						localStorage.getItem("customHomeMessage") !== "null" &&
						(localStorage.getItem("customHomeMessage") !== "" && (
							<div
								style={{
									// position: "relative",
									// background: "#fff",
									marginBottom: "1rem",
									textAlign: "left",
									display: "flex",
									justifyContent: "space-between",
									// background: "#fff",
									// color: "#000"
								}}
								className={'custom-message-block'}
							>
								<div style={{
									flexBasis: "20%",
									display: "flex",
									flexDirection: "column",
									justifyContent: "center",
									textAlign: "center",
									// padding: "1rem",
									// background: "rgba(255,255,255,0.66)",
									// borderRadius: "50%"
								}}>
									<i className={`f7-icons`} style={{fontSize: "4rem", color: "#fff"}}>exclamationmark_square_fill</i>
								</div>
								<p dangerouslySetInnerHTML={{
									__html: localStorage.getItem("customHomeMessage"),
								}} style={{flexBasis: "80%"}}></p>


							</div>
						))}

					{/*<div className={`greetings-container`}>
						<h3><span style={{position: "relative"}}>
							<span>Hello There</span> <img src={'/assets/img/various/NoPath.png'} />
						</span></h3>
						{(moment().hour() >= 7 && moment().hour() < 12) &&(
							<p>It's Breakfast Time!</p>
						)}

						{(moment().hour() >= 12 && moment().hour() < 16) &&(
							<p>It's Lunch Time!</p>
						)}

						{(moment().hour() >= 16 && moment().hour() < 19) &&(
							<p>It's Snack Time!</p>
						)}

						{(moment().hour() >= 19 && moment().hour() < 22) && (
							<p>It's Dinner Time!</p>
						)}

						{(moment().hour() >= 22 || moment().hour() < 7) && (
							<p>We're closed now. Come back at 7:30am.</p>
						)}

					</div>*/}

					{/* Passing slides as props to PromoSlider */}
					{/*{this.state.loadingSlider && (
						<React.Fragment>
						<div
							className="slider-wrapper secondary-slider-wrapper bg-light"
						>
						<ContentLoader
							height={170}
							width={400}
							speed={1}
							primaryColor="#f3f3f3"
							secondaryColor="#ecebeb"
						>
							<rect x="20" y="0" rx="4" ry="4" width="168" height="168" />
							<rect x="210" y="0" rx="4" ry="4" width="168" height="168" />
							<rect x="210" y="0" rx="4" ry="4" width="168" height="168" />
						</ContentLoader>
						</div>
						</React.Fragment>
					)}*/}

					<Link to="explore">
						<div
							className={`mock-search-block px-15 pb-10 ${
								localStorage.getItem("showPromoSlider") === "false"
									? "pt-15"
									: "" + promo_slides.mainSlides === "null"
										? "pt-15"
										: ""
							}`}
						>
							<div className="px-15 d-flex justify-content-between">
								<div>
									<span>Search items or stores</span>
								</div>
								<div>
									<i className="si si-magnifier"/>
								</div>
							</div>
						</div>
					</Link>

					{this.props.user && (
						<RunningStatus user={user}/>
					)}



					{promo_slides && !this.state.loadingSlider ? (
						<React.Fragment>

						{promo_slides && promo_slides.mainSlides && promo_slides.mainSlides.length > 0 && (
							<PromoSlider
								slides={promo_slides.mainSlides}
								slide_per_view={promo_slides.mainSlides[0]["promo_slider"]['slide_config']['slides_per_view']}
								slide_gap={promo_slides.mainSlides[0]["promo_slider"]['slide_config']['slide_gap']}
								size={promo_slides.mainSlides[0]["promo_slider"]["size"]}
							/>
						)}
					</React.Fragment>
					) : (
						<React.Fragment>
							<div
								className="slider-wrapper secondary-slider-wrapper bg-light"
							>
								<ContentLoader
									height={150}
									// width={360}
									// speed={1}
									// primaryColor="#f3f3f3"
									// secondaryColor="#ecebeb"
								>
									<rect x="20" y="0" rx="4" ry="4" height="1500" style={{
										borderRadius: "1rem",
										width: "100vw",
										height: "150px"
									}} />
								</ContentLoader>
							</div>
						</React.Fragment>
						)}
						{/*<React.Fragment>
							{promo_slides && promo_slides.mainSlides && promo_slides.mainSlides.length > 0 && (
								<PromoSlider
									slides={promo_slides.mainSlides}
									size={promo_slides.mainSlides[0]["promo_slider"]["size"]}
								/>
							)}
						</React.Fragment>*/}

					{(featured_stores && featured_stores.length > 0) ? (
						<FeaturedStores stores={featured_stores}></FeaturedStores>
					) : ("")}

					{(featured_items && featured_items.length > 0) ? (
						<FeaturedItems items={featured_items}></FeaturedItems>
					) : ("")}

					<RestaurantList user={user} slides={promo_slides.otherSlides}/>

					<Footer active_nearme={true}/>
				</div>

				<Dialog
					// maxWidth={false}
					fullWidth={true}
					fullScreen={false}
					open={this.state.open}
					onClose={this.toggleSchedulePopup}

					style={{margin: "auto", position: "absolute", bottom: "0", top: "0%"}}
					PaperProps={{
						style: {
							// backgroundColor: "#fff",
							overflowY: "hidden",
						},
					}}
				>
					<div>
						<GpsSelector fetchGpsAutomaticallyAndroid={true}/>
						{/*<div className="p-15 popularLocationPopup">
							{popular_locations && popular_locations.length > 0 && (
								<React.Fragment>
									<h4 className="text-muted h4">{localStorage.getItem("searchPopularPlaces")}</h4>

									<div style={{ overflowY: "scroll", height: "11rem" }}>
										{popular_locations.map((location) => (
											<button
												key={location.id}
												type="button"
												className="btn btn-rounded btn-alt-secondary btn-md mb-15 mr-15"
												style={{
													position: "relative",
													backgroundColor:
														location.is_default && localStorage.getItem("storeColor"),
													color: location.is_default && "#fff",
												}}
												onClick={() => {
													this.handlePopularLocationClick(location);
												}}
											>
												<Ink duration="500" />
												{location.name}
											</button>
										))}
									</div>
								</React.Fragment>
							)}
						</div>*/}
					</div>
				</Dialog>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	promo_slides: state.promo_slides.promo_slides,
	featured_stores: state.promo_slides.featured_stores,
	featured_items: state.promo_slides.featured_items,
	user: state.user.user,
	locations: state.locations.locations,
	languages: state.languages.languages,
	language: state.languages.language,
	popular_locations: state.popular_locations.popular_locations,
});

export default connect(
	mapStateToProps,
	{
		getPromoSlides,
		getFeaturedStores,
		getFeaturedItems,
		saveNotificationToken,
		getSingleLanguageData,
		getUserNotifications,
		resetInfo,
		resetItems,
		resetBackup,
	}
)(Home);
